import reduceReducers from 'reduce-reducers'
import { createReducer } from 'shared/notifications'
import {notifications} from './notifications'
import {Notification} from './types'

export const reducer = reduceReducers(
  ...notifications.map((n: Notification) => createReducer({prefix: n.key})),
)
